import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {VariableConfig} from "../../../../model/channels.model";

@Component({
  selector: "admin-channels-view-variables",
  templateUrl: "./variables.component.html",
  styleUrls: ["./variables.component.css"]
})
export class AdminChannelsViewVariablesComponent implements OnChanges {

  @Input() variables?: VariableConfig[];

  variableValues?: VariableConfig[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes["variables"]) {
      this.variableValues = this.variables;
    }
  }

}
